'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _ArticlesRead = require('./ArticlesRead.scss');var styles = _interopRequireWildcard(_ArticlesRead);
var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ArticlesRead = function ArticlesRead(props) {
    var recommendedArticles = [
    {
        images: _RealtorLanding2.default.connectionBetweenPublicTransport,
        link: '/articles/HJSb_6ILY',
        text: 'connectionBetweenPublicTransport' },

    {
        images: _RealtorLanding2.default.speciallyRealEstateAgents,
        link: '/articles/SJZYOpLIY',
        text: 'speciallyRealEstateAgents' },

    {
        images: _RealtorLanding2.default.sellAHouse,
        link: '/articles/rkRJ4P55u',
        text: 'sellAHouse' },

    {
        images: _RealtorLanding2.default.reliableBroker,
        link: '/articles/Hy_QV3j5O',
        text: 'reliableBroker' }];



    var renderCards = function renderCards() {return (
            recommendedArticles.map(function (item) {return (
                    _react2.default.createElement(_reactRouter.Link, { key: item.text, to: item.link },
                        _react2.default.createElement('div', { className: styles.cards },
                            _react2.default.createElement('img', { src: item.images, alt: '' }),
                            _react2.default.createElement('p', null, props.translate('RecommendedRrticles', item.text)))));}));};




    return (
        _react2.default.createElement('div', { className: styles.wrapper },
            _react2.default.createElement('p', { className: styles.title },
                props.translate('RecommendedRrticles', 'title')),

            _react2.default.createElement('div', { className: styles.cardsWrapper },
                renderCards())));



};

ArticlesRead.propTypes = {
    translate: _propTypes2.default.func };exports.default =


ArticlesRead;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticlesRead/ArticlesRead.js
// module id = 2603
// module chunks = 0